import './App.css';
import CalorieDeficitCalculator from './CalorieDeficitCalculator';




function App() {
  return <CalorieDeficitCalculator />
}

export default App;
